











































import Vue from 'vue'
import SingleDatePicker from '@/components/Notifications/SingleDatePicker.vue'
import TimePicker from '@/components/Notifications/TimePicker.vue'
import Emoji from '@/components/Notifications/Emoji.vue'
import { emptyForm, Notification } from '@/components/Notifications/constants'
import { apiCreateNotification, apiUpdateNotification, apiDeleteNotification } from '@/api'
import { mutations } from '@/state'
import moment from 'moment-timezone'

export default Vue.extend({
  name: 'ManageNotifications.vue',
  components: { SingleDatePicker, TimePicker, Emoji },
  data () {
    return {
      form: { ...emptyForm },
      id: null,
      pastNotification: false,
      emojiKey: null
    }
  },
  methods: {
    validate () {
      const { date, time, title, body } = this.form
      const isEmptyOrSpaces = (str: string) => str.match(/^ *$/) !== null
      return [date, time, title, body].some((v) => isEmptyOrSpaces(v))
    },
    setNotification (e: Notification) {
      this.form.title = e.title
      this.form.body = e.body
      this.$refs.SingleDatePicker.date = new Date(e.start).toISOString().substr(0, 10)
      this.$refs.TimePicker.time = new Date(e.start).toLocaleTimeString().substr(0, 5)
      this.id = e.id
      this.pastNotification = e.sent_at
    },
    resetForm () {
      this.$refs.SingleDatePicker.date = null
      this.$refs.TimePicker.time = null
      this.form = { ...emptyForm }
      this.id = null
      this.pastNotification = false
    },
    scheduleNotification () {
      if (this.validate()) {
        return mutations.setSnackbar('warning', this.t({ s: 'validationFailedMessage', component: 'Notifications' }))
      }
      mutations.setSnackbar()
      this.convertToUTC()
      apiCreateNotification(this.form).then(() => {
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      }).finally(() => {
        this.resetForm()
        this.$emit('resetCalendar')
      })
    },
    updateNotification () {
      if (this.validate()) {
        return mutations.setSnackbar('warning', this.t({ s: 'validationFailedMessage', component: 'Notifications' }))
      }
      mutations.setSnackbar()
      this.convertToUTC()
      apiUpdateNotification(this.id, this.form).then(() => {
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      }).finally(() => {
        this.resetForm()
        this.$emit('resetCalendar')
      })
    },
    async deleteNotification () {
      const { isConfirmed } = await this.sweetAlert(this.t({ s: 'confirmDeleteMessage', component: 'Notifications' }))
      if (!isConfirmed) return

      mutations.setSnackbar()
      apiDeleteNotification(this.id).then(() => {
        mutations.setSnackbar('success', this.t({ s: 'success', component: 'Snackbar' }))
      }).catch(e => {
        mutations.setSnackbar('error', e.response.data.message)
      }).finally(() => {
        this.resetForm()
        this.$emit('resetCalendar')
      })
    },
    convertToUTC () {
      const { date, time } = this.form
      const convertedDateTime = moment(moment(`${date} ${time}`).toDate()).utc().format('YYYY-MM-DD HH:mm')
      this.form.date = convertedDateTime.substr(0, 10)
      this.form.time = convertedDateTime.substr(11, 5)
    },
    openEmojis (key: string) {
      this.emojiKey = key
      this.$refs.OnHoverEmoji.$refs.EmojiInvoker.click()
    },
    appendEmoji (emoji: string) {
      this.form[this.emojiKey] += emoji
    }
  }
})
